const CONTINUATION_PARAM = "__coval_continue"

export function buildSigninContinuationHref(href: string) {
  const url = new URL(href, "https://coval.invalid")
  if (
    url.origin !== "https://coval.invalid" ||
    !url.pathname.startsWith("/") ||
    url.pathname.startsWith("//")
  ) {
    throw new Error("Expected a local sign-in URL")
  }
  url.searchParams.set(CONTINUATION_PARAM, "oauth")
  return `${url.pathname}${url.search}${url.hash}`
}

export { CONTINUATION_PARAM }
